import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { useLocation } from 'react-router'
import { useGetStep } from 'shared/hooks'
import { SpinnerLoader } from 'shared/ui'
import { StepsCommonLayout } from 'pages/settings/ui/StepsCommonLayout/StepsCommonLayout'
import { useProgressInfoTitle } from 'pages/settings/pages/numbers/pages/TextEnableLandline/hooks/useProgressInfoTitle'
import { useTextEnableLandlineStepsContext } from 'pages/settings/pages/numbers/pages/TextEnableLandline/context/useTextEnableLandlineStepsContext'
import { type TextEnableLandlineRoutesSteps } from 'pages/settings/pages/numbers/pages/TextEnableLandline/store/TextEnableLandlineStore'

export const TextEnableLandlineStepsLayout = observer(() => {
  const {
    numbersLayerStore,
    allStepsLength,
    decreaseStep,
    setCurrentStep,
    getSettingsStep,
    dispose,
    init,
    loading,
    hideBack,
  } = useTextEnableLandlineStepsContext()
  const settingsStep = useGetStep<TextEnableLandlineRoutesSteps>(getSettingsStep)
  const infoTitle = useProgressInfoTitle()
  const { search } = useLocation()

  useEffect(() => {
    init(search)

    return () => {
      dispose()
    }
  }, [])

  useEffect(() => {
    setCurrentStep(settingsStep)
  }, [settingsStep])

  if (loading) {
    return <SpinnerLoader ariaLabel={'textEnableLandlineStepsLayout'} />
  }

  return (
    <StepsCommonLayout
      progressTitle={infoTitle}
      totalSteps={allStepsLength}
      title='Text-enable landline'
      settingsStep={settingsStep}
      closeSetting={numbersLayerStore.redirectToRoot}
      decreaseStep={decreaseStep}
      hideBack={hideBack}
    />
  )
})
